// src/components/faq/FaqContactCta.tsx
import React from 'react';
import {Button} from '@dopomogai/ui';
import { MessageSquare } from 'lucide-react';

interface CtaData {
  headline: string;
  text: string;
  button: string;
}

interface FaqContactCtaProps {
  data: CtaData;
  onAction: (actionType: string, payload?: any) => void;
}

export const FaqContactCta: React.FC<FaqContactCtaProps> = ({ data, onAction }) => {
  if (!data) return null;

  const handleContactClick = () => {
    onAction('NAVIGATE_TO_PAGE', { path: '/#assessment' });
  };

  return (
    <section className="bg-slate-100 py-16 border-t-2 border-slate-200">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center bg-white p-10 rounded-xl border-2 border-black shadow-[6px_6px_0_0_black]">
          <div className="flex justify-center mb-4">
            <div className="p-3 bg-slate-100 border-2 border-black rounded-lg w-fit">
              <MessageSquare size={28} className="text-gray-800" />
            </div>
          </div>
          <h2 className="text-3xl font-bold text-gray-900">
            {data.headline}
          </h2>
          <p className="mt-4 text-slate-600 max-w-xl mx-auto">
            {data.text}
          </p>
          <div className="mt-8">
            <Button
              text={data.button}
              variant="primary"
              onClick={handleContactClick}
              size="lg"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

